import UserAgency from './UserAgency'
import UserRole from './UserRole'
import LuRole from './LuRole'
import TrackedBill from './TrackedBill'
export default class User {
  constructor(objIn = {}) {
    const defaults = {
      //ID is required
      ID: 0,
      FirstName: null,
      LastName: null,
      //Email is required
      Email: '',
      IsActive: true,
      OfficePhone: null,
      MobilePhone: null,
      Agency: null,
      Division: null,
    }
    let obj = {}
    Object.assign(obj, defaults, objIn)
    this.ID = obj.ID
    this.FirstName = obj.FirstName
    this.LastName = obj.LastName
    this.Email = obj.Email
    this.IsActive = obj.IsActive
    this.OfficePhone = obj.OfficePhone
    this.MobilePhone = obj.MobilePhone
    this.Agency = obj.Agency
    this.Division = obj.Division
    this.UserAgencies = []
    if (obj.UserAgencies) {
      obj.UserAgencies.forEach((item) => {
        this.UserAgencies.push(new UserAgency(item))
      })
    }
    this.UserRoles = []
    if (obj.UserRoles) {
      obj.UserRoles.forEach((item) => {
        this.UserRoles.push(new UserRole(item))
      })
    }
    this.AssignedBills = []
    if (obj.AssignedBills) {
      obj.AssignedBills.forEach((item) => {
        this.AssignedBills.push(new TrackedBill(item))
      })
    }
    this.Roles = []
    if (obj.Roles) {
      obj.Roles.forEach((item) => {
        this.Roles.push(new LuRole(item))
      })
    }
  }
  removeRelated() {
    let obj = Object.assign({}, this)
    obj.UserAgencies = []
    if (this.UserAgencies) {
      this.UserAgencies.forEach((item) => {
        if (item.removeRelated) {
          obj.UserAgencies.push(item.removeRelated())
        }
      })
    }
    obj.UserRoles = []
    if (this.UserRoles) {
      this.UserRoles.forEach((item) => {
        if (item.removeRelated) {
          obj.UserRoles.push(item.removeRelated())
        }
      })
    }
    obj.AssignedBills = null
    obj.Roles = null
    return obj
  }
  root() {
    let obj = Object.assign({}, this)
    obj.UserAgencies = null
    obj.UserRoles = null
    obj.AssignedBills = null
    obj.Roles = null
    return obj
  }
}
